import axios from "axios";
import global from "@/global";

let hzApi = axios.create({
    timeout: 5000
});

hzApi.interceptors.request.use(config => {
    let hzToken = localStorage.getItem(global.tokenKey);
    if (hzToken) {
        config.headers["htoken"] = hzToken
    }
    return config;
})

let filterParams = params => {
    if (typeof params === 'object') {
        let res = {};
        for (let field in params) {
            if (typeof params[field] !== 'undefined') {
                res[field] = params[field];
            }
        }
        return res;
    }
    return params;
}

export class Api {
    prefix = "/api";
    errHandler = (err, data) => {
        let code = data.code || -1;
        switch (code) {
            case 1401:
                localStorage.removeItem(global.tokenKey);
                break;
            default:
                alert(err);
        }
    };
    responseHandler = (res) => {
        let that = this;
        return new Promise(function (resolve, reject) {
            if (res.status === 200) {
                let code = res.data.code
                if (code === 1) {
                    return resolve(res.data.data)
                }
                if (typeof that.errHandler === 'function') {
                    return that.errHandler(res.data.msg, res.data);
                }
                return reject(res.data.msg, res.data);
            }
            return reject("请求失败", res.data);
        })
    };
    constructor(prefix) {
        if (prefix) {
            this.prefix+=prefix
        }
    }
    setPrefix(prefix) {
        this.prefix = prefix
        return this;
    }
    setResponseHandler(handler) {
        this.responseHandler = handler;
        return this;
    }
    setErrHandler(handler) {
        this.errHandler = handler
        return this;
    }
    get(url, params) {
        return this.request("get", url, {}, filterParams({params: params}))
    }
    post(url, data) {
        return this.request("post", url, filterParams(data))
    }
    request(method, url, data, config) {
        return hzApi.request(Object.assign({
            url: this.prefix+url,
            method: method,
            baseURL: global.httpUrl,
            data: data
        }, config)).then(res => {
            return this.responseHandler(res)
        })
    }
}

export class Price extends Api {
    constructor() {
        super("/price");
    }
    areas(id) {
        return this.get("/areas", {id:id})
    }
    fangjia(key, month) {
        return this.get("/fangjia", {key:key, month:month})
    }
    map(id) {
        return this.get("/map", {id:id})
    }
    hMap(id) {
        return this.get("/hMap", {id:id})
    }
}

export class Index extends Api {
    constructor() {
        super("/index");
    }
    recommend(codes) {
        return this.get("/recommend", {codes:codes})
    }
}

export class Login extends Api {
    constructor() {
        super("/login");
    }
    sendSmsCode(mobile, event) {
        return this.post("/sendSmsCode", {mobile: mobile, event: event})
    }
    mobileLogin(mobile, code, s_id, week) {
        return this.post("/mobileLogin", {mobile: mobile, code: code, s_id: s_id, week: week})
    }
    wxLogin(code, state) {
        return this.post("/wxLogin", {code:code, state:state});
    }
}

export class HzUser extends Api {
    constructor() {
        super("/HzUser");
    }
    info() {
        return this.get("/info");
    }
    logout() {
        return this.get("/logout")
    }
    /*
     * 手机号绑定，根据当前登录用户信息(登录或用户信息接口返回)判断用户是否存在手机号，没有手机号(!user.mobile)则需要绑定手机号
     * @param mobile 手机号
     * @param code 验证码
     * @param sid  短信ID，由发送验证码接口返回
     */
    mobileBind(mobile, code, sid) {
        return this.post("/mobileBind", {mobile: mobile, code: code, s_id: sid});
    }
    /*
     * 绑定经纪人接口，根据当前登录用户信息(登录或用户信息接口返回)判断用户是否存在手机号，没有手机号(!user.invite_emp_id)则需要绑定经纪人
     * @param emp_id 经纪人ID，可不传，默认随机绑定经纪人
     */
    employeeBind(emp_id) {
        return this.post("/employeeBind", {emp_id: emp_id});
    }
    getEmployee(n) {
        return this.get("/getEmployee", {n:n})
    }
    getAllEmployee(page, pageSize) {
        return this.get("/getAllEmployee", {page:page, page_size: pageSize})
    }
    houseLog(houseId, type, id) {
        return this.post("/houselog", {id: houseId, type: type, logid: id});
    }
}

export class NewHouse extends Api {
    constructor() {
        super("/newhouse");
    }
    getRecommend() {
        return this.get("/getRecommend")
    }
}

export class Other extends Api {
    getLouXunList(cate_id, page) {
        return this.get("/home/getLouxunList", {cate_id:cate_id, page:page})
    }
    adviserList(searchParams) {
        return this.get("/second/adviserList", searchParams);
    }
    adviserDetail(id) {
        return this.get("/second/adviserDetail", {id:id});
    }
    getTiaoJian(type) {
        return this.get("/home/getTiaojian", {type:type});
    }
}

export default {
    _: new Api(),
    Price: new Price(),
    Index: new Index(),
    Login: new Login(),
    User: new HzUser(),
    NewHouse: new NewHouse(),
    Other: new Other()
}
